const NAME = "ANNOTATIONS_PAGE";

export default NAME;
